import { FC } from "react";
import { Box } from "@mui/material";

export const DesktopListViewLayout: FC = ({ children }) => (
    <Box sx={{ display: "flex", height: "100%" }}>
        <Box sx={{ flexGrow: 1 }}>{children}</Box>
    </Box>
);
